import React, { useContext, useImperativeHandle, useState, useMemo, useRef, useEffect } from 'react';
import { Button, Modal, message, Tabs, Empty } from 'antd';
import type { SpComListType } from '../../index';
import SelectTreeV2 from './../filterTree/components/SelectTreeV2';
import SPFilterRecordList from './components/SPFilterRecordList';
import styles from './../filterTree/index.module.less';
import { getShowTreeDataFromApiName, featchTableData } from './../filterTree/service';
import { GetFilterTableSchema } from './../filterTree/effect/GetFilterTableSchema';
import { SmileOutlined } from '@ant-design/icons';
import SpQiankun from '../../../sp-qiankun';
import { cloneDeep } from 'lodash';

const FilterTree: React.FC<SpComListType> = function FilterTree(props) {
  const { metaConfig = {}, values = {}, onChange, _rowId, _headId } = props;
  const { freeComponentsConfig = {}, taskInfo = {}, index, pageType } = metaConfig;
  const mainModule = freeComponentsConfig && freeComponentsConfig['position-module'];
  const mainRecordValues = JSON.stringify(values && values[mainModule]);
  const [tableValues, setTableValues] = useState<any>({});

  const [mainRecord, setMainRecord] = useState<any>({});
  // 树图数据
  const [showTreeData, setShowTreeData] = useState<any>();
  const [showTreeList, setShowTreeList] = useState<any>([]);
  // 树图选中
  const [activeKey, setActiveKey] = useState<string>();
  const [activeData, setActiveData] = useState<any>();

  const [changeData, setChangeData] = useState<string>('{}');
  const [visible, setVisible] = useState<boolean>(false);
  const [recordId, setRecordId] = useState<string>('');

  const getShowTreeDataFromApi = async (data: any) => {
    const resData = await getShowTreeDataFromApiName(data, freeComponentsConfig.treeApi);
    setShowTreeData(resData.treeData);
    setShowTreeList(resData.treeList);
  };
  const getTableValues = async (data: any) => {
    const cpartCode = data?.cpart_code;
    if (!cpartCode) return;
    const resData = await featchTableData(cpartCode);
    setTableValues(resData?.listValue);
    setRecordId(resData?.recordId);
    return resData?.listValue;
  };
  useMemo(() => {
    const dataSource = mainRecordValues || '{}';
    const newRecordData = JSON.parse(dataSource);
    const newMainRecord = index || index === 0 ? newRecordData[index] : newRecordData;
    setMainRecord(newMainRecord);
    const reField = freeComponentsConfig?.apiField?.split(',');
    const newData: any = JSON.parse(changeData);
    reField.map((el: string) => {
      newData[el] = newMainRecord[el];
    });
    const newDataSt = JSON.stringify(newData);
    if (newDataSt !== changeData) {
      setChangeData(newDataSt);
      getShowTreeDataFromApi(newMainRecord);
      getTableValues(newMainRecord);
    }
  }, [mainRecordValues]);

  const onSelectNodeChange = (data: any, selected: boolean) => {
    if (!selected) {
      setActiveKey(data && data[freeComponentsConfig?.treeRelationField]);
      setActiveData(data);
    } else {
      setActiveKey(undefined);
      setActiveData(undefined);
    }
  };

  const { filterTableSchema } = GetFilterTableSchema({
    config: freeComponentsConfig,
    schemaTree: taskInfo.relationTree,
    metaConfig,
    values,
  });

  const getArrEqual = (arr1: string[], arr2: string[]) => {
    const newArr: string[] = [];
    for (let i = 0; i < arr2.length; i++) {
      for (let j = 0; j < arr1.length; j++) {
        if (arr1[j] === arr2[i]) {
          newArr.push(arr1[j]);
        }
      }
    }
    return newArr;
  };


  const onSaveCb = async () => {
    setVisible(false);
    const resData = await getTableValues(mainRecord);
    const cpartModule = Object.keys(resData || {});
    const npiModule = Object.keys(values || {});
    const keyModules = getArrEqual(cpartModule, npiModule);
    const newAllData: any = {};
    keyModules.forEach((el: string) => {
      resData[el]?.forEach((item: any) => {
        if (_headId && _rowId) {
          item[_headId] = mainRecord[_rowId];
        }
      });
      const oldData = cloneDeep(values[el] || []);
      const otherData = oldData?.filter((item: any) => item[_headId] !== mainRecord[_rowId]);
      newAllData[el] = otherData.concat(resData[el]);
    });
    onChange({
      // ...values,
      ...newAllData,
    });
    console.log('featchTableData----newAllData', newAllData);
  };

  return (
    <>
      <div className={styles.line_box}>
        {
          showTreeData && (
            <div className={styles.tree_box}>
              <SelectTreeV2
                data={showTreeData}
                onChange={setShowTreeData}
                handleNodeClick={onSelectNodeChange}
                currentSelectNode={activeData}
              />
            </div>
          )
        }
        <div className={styles.tabs_box}>
          {showTreeData && (
          <Tabs
            type="line"
            size="large"
            centered={false}
            tabPosition="top"
            keyboard={false}
          >
            {filterTableSchema.map((module: any, i) => {
              return (
                <Tabs.TabPane tab={module?.props.tab} key={module?.props.key} forceRender>
                  {module.children?.map((m: any) => {
                    const allValues = tableValues ? tableValues[module.handle] : [];
                    return (
                      <SPFilterRecordList
                        value={allValues || []}
                        mainRecordValue={mainRecord}
                        showTreeList={showTreeList}
                        showTreeData={showTreeData}
                        filterProps={module.filterProps}
                        activeKey={activeKey}
                        activeData={activeData}
                        metaConfig={metaConfig}
                        _headIdField={_headId}
                        headIdData={mainRecord[_rowId]}
                        {...m.props}
                      />
                    );
                  })}
                </Tabs.TabPane>
              );
            })}
          </Tabs>
          )}
        </div>
      </div>
      {showTreeData && pageType !== 'view' && (
        <div style={{ textAlign: 'center', marginTop: '12px' }}>
          <Button type="primary" onClick={() => setVisible(true)}>编辑产品结构信息</Button>
        </div>
      )}
      {!showTreeData && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
      <Modal
        title="编辑客户产品"
        visible={visible}
        onCancel={() => {
          setVisible(false);
          getTableValues(mainRecord);
        }}
        width={1000}
        footer={null}
        destroyOnClose
        maskClosable={false}
      >
        <SpQiankun
          saveCb={onSaveCb}
          modal
          qiankun={{}}
          routeUrl={`/lcp/task/TASK20221209134843676460/edit/${recordId}?type=npi`}
        />
      </Modal>
    </>
  );
};

export default FilterTree;
